const Color = {
    primary: '#00B0E1',
    secondary: '#EF7D00',
    green: '#06C755',
    gray: '#878787',
    yellow: '#F4D011',
    blueDark:'#2d4f93',
}
export const ColorsDisplay = {
    background: "#f2f2f2",
    blueTheme: "#4da7da",
    redTheme: "#ff3333"
}
export default Color